import { SessionModel } from '../sessions/models/session';

export function CoreRun (
  $rootScope: any,
  $window   : ng.IWindowService
) {
  $window.isResolving = ( isResolving : boolean ) => {
    $rootScope.resolving = isResolving;
  };

  $window.session = ( session : SessionModel ) => {
    $rootScope.session = session;
  };
}
